import React from 'react'

import CustomFieldInput from '../../../../../../components/molecules/CustomFieldInput'

import { checkIsEditable } from './helpers'
import useCustomFieldValues from '@SonarCX/hooks/useCustomFieldValues'
import useStyles from './styles'

export type PillValueProps = {
  field: LocalCustomField
  value: string
  setValue: (value: string) => void
  advanced?: boolean
}

const PillValue: React.FC<PillValueProps> = ({
  field,
  value,
  setValue,
  advanced
}) => {
  const meta = React.useMemo(() => {
    const metaVal: APIMeta = {
      key: field.id,
      value,
      row: undefined,
      row_key: undefined
    }

    return [metaVal]
  }, [field, value])

  const updateMetaVal = React.useCallback(
    (_: string, val: string) => {
      setValue(val)
    },
    [setValue]
  )

  const { handleValueChange } = useCustomFieldValues({ meta, updateMetaVal })

  const classes = useStyles()

  if (!checkIsEditable(field, advanced)) {
    return null
  }

  return (
    <div className={classes.root}>
      <CustomFieldInput
        field={field}
        value={value}
        handleChange={handleValueChange}
        meta={meta}
        canEdit
        inputOnly
        inTable
      />
    </div>
  )
}

export default PillValue
